module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-transition-link/gatsby-browser.js'),
      options: {"plugins":[],"layout":"/Users/joellopez/Library/Mobile Documents/com~apple~CloudDocs/Macbook Pro 16/Trabajo/Nexxos/WEB-esenios_propiedades/src/layout/index.js"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"aa0d40ec8ea3137c297e495d5626e445"},
    }]
